import { render, staticRenderFns } from "./Embeddable.vue?vue&type=template&id=c6d266a6&scoped=true"
import script from "./Embeddable.vue?vue&type=script&lang=ts"
export * from "./Embeddable.vue?vue&type=script&lang=ts"
import style0 from "./Embeddable.vue?vue&type=style&index=0&id=c6d266a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d266a6",
  null
  
)

export default component.exports